import { AuthService } from './../../services/auth.service';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfigureFiberDialogComponent } from '../../dialogs/configure-fiber-dialog/configure-fiber-dialog.component';
import { SuccessDialogComponent } from '../../dialogs/success-dialog/success-dialog.component';
import { MasipService } from '../../services/masip.service';
import { ConfigureTelephoneLineComponent } from '../../dialogs/configure-telephone-line/configure-telephone-line.component';
import { Router } from '@angular/router';
import { SearchbarComponent } from '../../components/searchbar/searchbar.component';

@Component({
  selector: 'app-my-lines',
  templateUrl: './my-lines.component.html',
  styleUrl: './my-lines.component.scss',
  standalone: false
})
export class MyLinesComponent {
  @Input() selectedGroup: any = [];
  @Input() selectedProfile: any;
  @Input() isInside: boolean = true;
  @Output() linesSelected = new EventEmitter<any[]>();

  displayedColumns: string[] = ['num', 'alias', 'short', 'actions'];
  data: any[] = [];
  lineInfo: any[] = [];
  selectedLines: any[] = [];

  currentView: string = 'fiber';
  errorMessage: string = '';

  telephone: string = '';
  ip: string = '';
  alias: string = '';
  group: string[] = [];
  groups: any[] = [];

  lines!: Map<string, Map<string, any>>;
  groupsMap: any[] = [];

  isDropdownOpen = false;
  selectedGroups: any[] = [];

  loading: boolean = true;
  loadingGroups: boolean = false;
  showDetails: boolean = false;
  isFiber: boolean = false;
  isLines: boolean = false;
  isFixed: boolean = false;
  isConfigurations: boolean = false;
  showFiberConfiguration: boolean = false;
  showTelephoneConfiguration: boolean = false;
  inGroup: boolean = false;
  showSelection: boolean = false;
  groupExpanded: boolean = true;
  isFiltered: boolean = false;
  clearSearch: boolean = false;

  isMarketingOpen = true;
  isSoporteOpen = true;

  searched: string = '';

  actualPage: number = 1;
  totalPages: number = 1;

  userFiscalId: any;
  loadingApi: boolean = false;

  profiles: any;

  @ViewChild(SearchbarComponent) searchbarComponent!: SearchbarComponent;

  constructor(private dialog: MatDialog, protected router: Router, private masipService: MasipService, private authService: AuthService) { }

  ngOnInit() {

    if (this.router.url != '/grupos' && this.router.url != '/perfiles') {
      this.masipService.setApiLoadingGlobal(false);
    }
    this.masipService.apiLoadingStorage.subscribe(resp => {
      this.loadingApi = resp;
    })
    if (localStorage.getItem('accessAsUser') !== null) {
      this.userFiscalId = String(localStorage.getItem('accessAsUser') || '');
    }
    this.getGroups(this.userFiscalId);

    if (this.router.url === '/grupos') {
      console.log(this.selectedGroup);

      this.currentView = 'lines';
      this.isConfigurations = true;
      this.showSelection = true;
      this.isLines = true;

      this.selectedGroup.lines.forEach((line: any) => {
        this.selectedLines.push(line.phone_number);
      });

      // this.group.selected = this.selectedGroup;
      // this.loadLines();
      console.log(this.isInside);

      if (this.isInside) {

        this.updateSelection(this.selectedGroup);
      } else {
        const arrayGroups = this.groups.filter(group => group.id !== this.selectedGroup.id);
        console.log(arrayGroups);

        this.masipService.getGroups(this.userFiscalId).subscribe(resp => {
          const groups = resp;
          const arrayGroups = groups.filter((group: { id: any; }) => group.id !== this.selectedGroup.id);
          console.log(arrayGroups);

          this.updateSelection(arrayGroups);
        }
        )

        // this.loadLines();
      }
      // this.masipService.setApiLoadingGlobal(true);
    } else if (this.router.url === '/perfiles') {
      console.log(this.selectedProfile);

      this.currentView = 'lines';
      this.isConfigurations = true;
      this.showSelection = true;
      this.isLines = true;

      this.selectedProfile.lines.forEach((line: any) => {
        this.selectedLines.push(line.phone_number);
      });

      if (this.isInside) {

        this.updateSelection(this.selectedProfile);
      } else {
        this.masipService.getProfilesByUser(this.userFiscalId).subscribe(resp => {
          this.profiles = resp;
          const arrayProfiles = this.profiles.filter((profile: { id: any; }) => profile.id !== this.selectedProfile.id);
          console.log(arrayProfiles);
          this.updateSelection(arrayProfiles);
        })
      }
    } else {
      this.loadLines();
    }
  }

  ngAfterViewInit() {
    console.log(this.loadingGroups);

  }

  changeView(view: string) {
    this.currentView = view;
    switch (view) {
      case 'fiber':
        if (this.searchbarComponent) {
          this.searchbarComponent.clearInput();
        }
        this.isFiber = true;
        this.isLines = false;
        this.isFixed = false;
        this.loadLines();
        break;
      case 'lines':
        if (this.searchbarComponent) {
          this.searchbarComponent.clearInput();
        }
        this.isFiber = false;
        this.isLines = true;
        this.isFixed = false;
        this.loadLines();
        break;
      case 'fixed':
        if (this.searchbarComponent) {
          this.searchbarComponent.clearInput();
        }
        this.isFiber = false;
        this.isLines = false;
        this.isFixed = true;
        this.loadLines();
        break;
      default:
        break;
    }

  }

  getHeader(): string {
    switch (this.currentView) {
      case 'lines':

        return 'Nº Teléfono';
      case 'fiber':

        return 'Nº IP'
      default:
        return ''
    }
  }

  getData(element: any): any {
    if (element) {
      switch (this.currentView) {
        case 'lines':
          return element.telefono;
        case 'fiber':
          if (element.ip) {
            return element.ip;
          } else {
            return 'Router sin IP asignada';
          }
        default:
          return ''
      }
    } else {
      return '';
    }
  }

  searchData(by: any) {
    this.searched = by;
    this.loadLines(1, by);

  }

  searchGroup(by: any) {
    // this.loadLines(1, '',by);
    console.log(by);
    this.loading = true;
    this.loadingGroups = true;
    this.masipService.setApiLoadingGlobal(true);
    this.masipService.setApiLoading(true);
    this.data = [];
    this.groupsMap = [];
    const search = '';
    const page = 0;
    const num = 0

    if (this.router.url === '/grupos') {
      this.masipService.getLinesByUser(num, page, this.userFiscalId, 0, search, by).subscribe(resp => {
        this.data = resp.data;
        this.isFiltered = true;

        this.group = Object.keys(resp.data);


        this.group.forEach((e: any) => {
          let lineMap = new Map();
          lineMap.set("nombre", e);
          if (this.selectedGroup) {
            console.log(resp);

            let lineas = resp.data[e].map((line: any) => {
              let inGroup = e === this.selectedGroup.name;

              return {
                ...line,
                inGroup
              };
            });
            lineMap.set("lineas", lineas);

            if (!this.isInside) {
              this.masipService.getLinesWithoutGroup(this.userFiscalId, 9, page).subscribe(resp => {

                this.data = resp.data.data;
                this.isFiltered = true;

                this.group = Object.keys(resp.data.data);

                this.group.forEach((e: any) => {
                  let lineMap = new Map();
                  lineMap.set("nombre", e);
                  if (this.selectedGroup) {

                    let lineas = resp.data.data[e].map((line: any) => {
                      let inGroup = e === this.selectedGroup.name;

                      return {
                        ...line,
                        inGroup
                      };
                    });
                    lineMap.set("lineas", lineas);
                  } else {
                    lineMap.set("lineas", resp.data[e]);
                  }
                  lineMap.set("expanded", true);

                  this.groupsMap.push(Object.fromEntries(lineMap));

                });

              }
              );
            }
          } else {
            lineMap.set("lineas", resp.data[e]);
          }
          lineMap.set("expanded", true);

          this.groupsMap.push(Object.fromEntries(lineMap));

        });

        this.masipService.setApiLoading(false);
        this.loadingGroups = false;
        console.log(this.loadingGroups);

      },
        error => {
          this.loadingGroups = false;
          this.masipService.setApiLoading(false);
          this.data = [];
          this.isFiltered = false;
        })
    } else if (this.router.url === '/perfiles') {
      console.log('entra');

      this.masipService.getLinesByUser(num, page, this.userFiscalId, 0, search, [], by).subscribe(resp => {
        console.log(resp);

        this.data = resp.data;
        this.isFiltered = true;

        this.group = Object.keys(resp.data);


        this.group.forEach((e: any) => {
          let lineMap = new Map();
          lineMap.set("nombre", e);
          if (this.selectedProfile) {
            let lineas = resp.data[e].map((line: any) => {
              let inGroup = this.selectedProfile.lines.some((l: any) => l.phone_number === line.telefono);
              return {
                ...line,
                inGroup
              };
            });
            lineMap.set("lineas", lineas);
            console.log(this.isInside);

            if (!this.isInside) {
              this.masipService.getLinesWithoutProfile(this.userFiscalId, 9, page).subscribe(resp => {
                console.log(resp);

                this.data = resp.data.data;
                this.isFiltered = true;

                this.group = Object.keys(resp.data.data);
                console.log(this.group);

                this.group.forEach((e: any) => {
                  let lineMap = new Map();
                  lineMap.set("nombre", e);
                  if (this.selectedGroup) {
                    console.log(resp);

                    let lineas = resp.data.data[e].map((line: any) => {
                      let inGroup = e === this.selectedGroup.name;

                      return {
                        ...line,
                        inGroup
                      };
                    });
                    lineMap.set("lineas", lineas);
                  } else if (this.selectedProfile) {
                    let lineas = resp.data[e].map((line: any) => {
                      let inGroup = this.selectedProfile.lines.some((l: any) => l.phone_number === line.telefono);
                      return {
                        ...line,
                        inGroup
                      };
                    });
                    lineMap.set("lineas", lineas);
                  } else {
                    lineMap.set("lineas", resp.data[e]);
                  }
                  lineMap.set("expanded", true);

                  this.groupsMap.push(Object.fromEntries(lineMap));

                });

              }
              );
            }
          } else {
            lineMap.set("lineas", resp.data[e]);
          }
          lineMap.set("expanded", true);

          this.groupsMap.push(Object.fromEntries(lineMap));

        });

        this.masipService.setApiLoading(false);
        this.loadingGroups = false;
        this.masipService.setApiLoadingGlobal(false);

        console.log(this.loadingGroups);

      },
        error => {
          this.loadingGroups = false;
          this.masipService.setApiLoading(false);
          this.masipService.setApiLoadingGlobal(false);

          this.data = [];
          this.isFiltered = false;
        })
    } else {
      this.masipService.getLinesByUser(num, page, this.userFiscalId, 0, search, by).subscribe(resp => {
        this.data = resp.data;
        this.isFiltered = true;

        this.group = Object.keys(resp.data);


        this.group.forEach((e: any) => {
          let lineMap = new Map();
          lineMap.set("nombre", e);
          if (this.selectedGroup) {
            console.log(resp);

            let lineas = resp.data[e].map((line: any) => {
              let inGroup = e === this.selectedGroup.name;

              return {
                ...line,
                inGroup
              };
            });
            lineMap.set("lineas", lineas);
          } else if (this.selectedProfile) {
            let lineas = resp.data[e].map((line: any) => {
              let inGroup = this.selectedProfile.lines.some((l: any) => l.phone_number === line.telefono);
              return {
                ...line,
                inGroup
              };
            });
            lineMap.set("lineas", lineas);
          } else {
            lineMap.set("lineas", resp.data[e]);
          }
          lineMap.set("expanded", true);

          this.groupsMap.push(Object.fromEntries(lineMap));

        });

        this.masipService.setApiLoading(false);
        this.loadingGroups = false;
        console.log(this.loadingGroups);

      },
        error => {
          this.loadingGroups = false;
          this.masipService.setApiLoading(false);
          this.masipService.setApiLoadingGlobal(false);

          this.data = [];
          this.isFiltered = false;
        })
    }
    this.masipService.setApiLoading(false);
    this.masipService.setApiLoadingGlobal(false);

    this.loadingGroups = false;
    this.loading = false;
  }

  getGroups(fiscal_id: string) {
    this.masipService.getGroups(fiscal_id).subscribe(resp => {
      this.groups = resp;

    }
    )
  }

  changePage(page: number) {
    this.loadLines(page, this.searched);
  }

  loadLines(page: number = 1, search: string = '', group: any = '') {
    this.loading = true;
    this.masipService.setApiLoadingGlobal(false);
    this.masipService.setApiLoading(true);
    this.data = [];
    this.groupsMap = [];

    switch (this.currentView) {
      case 'lines':
        this.masipService.getLinesByUser(9, page, this.userFiscalId, 0, search, group).subscribe(resp => {
          this.data = resp.data.data;
          this.group = Object.keys(resp.data.data);
          console.log(this.data);

          this.group.forEach((e: any) => {
            // if (!this.isInside && this.selectedGroup.name === e) {
            //   return; // No agregar este elemento al array
            // } else {

            let lineMap = new Map();
            lineMap.set("nombre", e);

            if (this.selectedGroup) {
              let lineas = resp.data.data[e].map((line: any) => {
                let inGroup = e === this.selectedGroup.name;
                return {
                  ...line,
                  inGroup
                };
              });
              lineMap.set("lineas", lineas);
            } else if (this.selectedProfile) {
              let lineas = resp.data.data[e].map((line: any) => {
                let inGroup = this.selectedProfile.lines.some((l: any) => l.phone_number === line.telefono);
                return {
                  ...line,
                  inGroup
                };
              });
              lineMap.set("lineas", lineas);
            } else {
              lineMap.set("lineas", resp.data.data[e]);
            }

            lineMap.set("expanded", true);
            this.groupsMap.push(Object.fromEntries(lineMap));
            // }

          });

          console.log(this.groupsMap);

          this.totalPages = resp.data.total_pages;
          this.actualPage = resp.data.current_page;
          this.masipService.setApiLoading(false);
          this.loading = false;
        },
          error => {
            this.loading = false;
            this.masipService.setApiLoading(false);
            this.data = [];
          });
        break;

      case 'fiber':
        this.isFiber = true;
        this.masipService.getFiberByUser(9, page, this.userFiscalId, search).subscribe(resp => {
          this.data = resp.data.data;
          console.log(this.data);
          
          this.totalPages = resp.data.total_pages;
          this.actualPage = resp.data.current_page;
          this.loading = false;
          this.masipService.setApiLoading(false);
        },
          error => {
            this.loading = false;
            this.masipService.setApiLoading(false);
            this.data = [];
          });
        break;

      case 'fixed':
        this.masipService.getFixedLines(9, page, this.userFiscalId).subscribe(resp => {
          this.data = resp.data;
          console.log(resp);
          this.totalPages = resp.total_pages;
          console.log(this.totalPages);
          
          this.actualPage = resp.current_page;
          this.loading = false;
          this.masipService.setApiLoading(false);
        });
        break;

      default:
        break;
    }
  }

  updateSelectedLines(line: any) {
    if (line.inGroup) {
      // Si se marca, añadir si no está en la lista
      if (!this.selectedLines.some(l => l === line.telefono)) {
        this.selectedLines.push(line.telefono);
      }
    } else {
      // Si se desmarca, eliminar de la lista
      this.selectedLines = this.selectedLines.filter(l => l !== line.telefono);
    }
    this.linesSelected.emit(this.selectedLines);
  }

  toggleGroup(group: any) {
    group.expanded = !group.expanded;
  }



  openConfiguration(element: any) {


    if (this.currentView == 'fiber') {
      this.ip = element.ip;
      this.showFiberConfiguration = true;
      // const dialogRef = this.dialog.open(ConfigureFiberDialogComponent, {
      //   panelClass: 'big-dialog',
      //   data: {
      //     ip: element.ip,
      //   }
      // });
      // return dialogRef.afterClosed();
    }
    if (this.currentView == 'lines') {
      this.telephone = element.telefono;
      this.showTelephoneConfiguration = true;
      // const dialogRef = this.dialog.open(ConfigureTelephoneLineComponent, {
      //   panelClass: 'big-dialog',
      //   data: {
      //     telephone: element.telefono,
      //   }
      // });
      // return dialogRef.afterClosed();
    }
    return '';
  }

  openDetails(element: any) {
    this.lineInfo = element;
    this.showDetails = true;
  }

  changeDetails(nuevoEstado: boolean) {
    this.showDetails = nuevoEstado;
    if (this.searchbarComponent) {
      this.searchbarComponent.clearInput();
    }
    this.loadLines();
  }

  closeConfiguration(nuevoEstado: boolean) {
    this.showFiberConfiguration = nuevoEstado;
    this.showTelephoneConfiguration = nuevoEstado;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  getProfiles() {

  }


  updateSelection(group: any) {
    console.log(group);
    console.log(group.selected);
    if (this.router.url === '/grupos') {
      if (this.isInside) {

        this.selectedGroups.push(group.id);
      } else {
        group.forEach((group: any) => {

          this.selectedGroups.push(group.id);
        });
        console.log(this.selectedGroups);
      }
    } else if (this.router.url === '/perfiles') {
      if (this.isInside) {
        this.selectedGroups.push(group.id);
      } else {
        console.log(group);

        group.forEach((group: any) => {
          this.selectedGroups.push(group.id);
        });
        console.log(this.selectedGroups);
      }
    } else {
      if (group.selected) {
        this.selectedGroups.push(group.id);
        console.log(this.selectedGroups);
      } else {
        this.selectedGroups = this.selectedGroups.filter(g => g !== group.id);


      }
    }

    if (this.selectedGroups.length === 0) {
      this.loadLines();
      this.isFiltered = false;
      console.log('entra');

    } else {
      this.searchGroup(this.selectedGroups);
    }
  }
}
